export const DisableReason = {
  none: 'none',
  userEnabled: 'usr_enabled',
  emailInviteMeetCreated: 'email_invite_meet_created',
  confNotFound: 'conf_not_found',
  cannotDial: 'cannot_dial',
  nonDialService: 'non_dial_service',
  disableLimitFilter: 'limit_mf',
  disableRestDomainsFilter: 'rd_mf',
  disableRecordingFeatureFilter: 'rec_mf',
  disablePhonebotFeatureFilter: 'phonebot_mf',
  disableRecurMeetFilter: 'recur_mf',
  disableDoNotDialFilter: 'dnd_mf',
  disableInternalMeetFilter: 'int_mf',
  disableExternalMeetFilter: 'ext_mf',
  disableOrganizerOnlyFilter: 'org_only_mf',
  disableAcceptedFilter: 'acc_mf',
  disableDuplicateMeetingFilter: 'dup_mf',
  userDisabled: 'usr_disabled',
  automationDisabled: 'automation_disabled',
  automationEnabled: 'automation_enabled'
};

export const RecordingState = {
  enabled: 'enabled',
  disabled: 'disabled'
};

export const isAutomationRecordOnly = (meeting, disableReason) =>
  disableReason === DisableReason.automationEnabled &&
  Boolean(meeting?.attributedUserData?.recordingOnly);
